import Dashboard from "../Layout/Dashboard";
import { Button } from 'primereact/button';
import { BASE_URL } from "../constants";
import { getAuthHeader } from "../utils";

export default function GenerateToken() {

    return (
        <Dashboard>
            <div className="card">
                <h2>Generar Token</h2>
                <p>
                    Para generar un token JWT para tu aplicación, necesitas descargar un archivo de configuración 
                    que contiene las credenciales necesarias. Este archivo se utiliza para autenticar tu aplicación con el
                    servidor de seguros.
                </p>
                <p>
                    Presiona el botón <b>Descargar</b> para obtener un archivo <code>.env</code>. 
                    Luego, coloca ese archivo <code>.env</code> en el directorio de tu proyecto donde se encuentra el archivo <code>.dll</code>.
                </p>
                <p>
                    Si tienes dudas, contacta al administrador del sistema para más información.
                </p>
                <DownloadTokenButton />
            </div>
        </Dashboard>
    );
}

// Agrega este componente dentro del mismo archivo:
function DownloadTokenButton() {
    const handleDownload = async () => {
        try {
            const response = await fetch(`${BASE_URL}insurance/api/token/generate/`, {
                method: "POST",
                headers: {
                    ...getAuthHeader(),
                },
            });

            if (!response.ok) {
                throw new Error(JSON.stringify(response));
            }

            const data = await response.json();
            const envContent = 
                `MEDICAL_API_ACCESS_TOKEN=${data.access}\n` +
                `MEDICAL_API_REFRESH_TOKEN=${data.refresh}\n` +
                `MEDICAL_API_EXPIRES_AT=${data.expires_at}\n`;

            const blob = new Blob([envContent], { type: "text/plain" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = ".env";
            a.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            alert(error.message);
        }
    };

    return (
        <Button label="Descargar Token" icon="pi pi-download" onClick={handleDownload} className="p-button-success" />
    );
}